<template>
  <div class="partner-offer-catalog">
    <div class="row prizes__row">
      <div
        v-for="offerItem in offerList"
        :key="offerItem.id"
        class="col-xl-3 col-lg-4 col-md-6 prizes__col"
      >
        <PartnerOfferCard
          style="max-width: 420px;"
          class="mb-4"
          :offer="offerItem"
          @offerOpen="$emit('partnerOfferOpen')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PartnerOfferCard from '@/components/PartnerOffer/PartnerOfferCard.vue';

export default {
  name: 'PartnerOfferCatalog',
  components: { PartnerOfferCard },
  props: {
    offerList: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.partner-offer-catalog {
  min-height: 300px;
  padding: 38px 38px 14px 38px;
  background: #F5F5F5;
  border-radius: 8px;
}
</style>
